import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { s } from "@/shared/strings";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Logo } from "@/shared/components/Logo";

export function Landing() {
  const [code, setCode] = useState("");
  const nav = useNavigate();

  const go = () => {
    if (code.length === 6) nav(`/j/${code}`);
  };

  return (
    <main className="bg-bg flex min-h-dvh flex-col items-center justify-center gap-10 px-6 py-12">
      <Logo size="lg" />

      <form
        className="flex w-full max-w-md flex-col items-center gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          go();
        }}
      >
        <label htmlFor="room-code" className="semi-expanded text-28 text-chalk font-bold">
          {s.codePrompt}
        </label>
        <Input
          id="room-code"
          value={code}
          onChange={(e) =>
            setCode(
              e.target.value
                .toUpperCase()
                .replace(/[^A-Z]/g, "")
                .slice(0, 6),
            )
          }
          placeholder="ABCDEF"
          autoComplete="off"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          inputMode="text"
          aria-invalid={code.length > 0 && code.length < 6}
          className="expanded text-40 text-amber placeholder:text-chalk-3/40 h-20 max-w-xs text-center font-black tracking-[0.3em]"
        />
        <Button type="submit" size="lg" className="w-full max-w-xs" disabled={code.length !== 6}>
          Entrar
        </Button>
      </form>

      <div className="text-chalk-3 flex flex-col items-center gap-3">
        <span className="text-14">{s.tagline}</span>
        <Link
          to="/entrar"
          className="text-16 text-chalk-2 hover:text-amber font-semibold underline-offset-4 hover:underline"
        >
          {s.imAHost} →
        </Link>
      </div>

      {/* Demonstração honesta: frames reais do palco durante uma partida
          (capturados por scripts/capture-demo.mjs, docs/06 M6). */}
      <figure className="flex w-full max-w-2xl flex-col items-center gap-3">
        <img
          src="/demo-stage.webp"
          alt="Palco da Arena em uma partida real: código e QR no lobby, pergunta de múltipla escolha com timer, revelação com respostas do grupo e placar final."
          width={960}
          height={540}
          loading="lazy"
          className="border-line w-full rounded-xl border"
        />
        <figcaption className="text-14 text-chalk-3 text-center">
          O palco em uma partida de verdade — projetado para ser lido a metros de distância.
        </figcaption>
      </figure>
    </main>
  );
}
